import type { DatasetIconProps } from "./DatasetIcon.type";

import { AiFillFile, AiOutlineFile } from "react-icons/ai";

const FileIcon = ({ filled }: DatasetIconProps) => {
  return filled ? <AiFillFile /> : <AiOutlineFile />;
};

export default FileIcon;
